import React, { useState, useEffect } from "react";

import styled from "@emotion/styled";

import Typography from "@material-ui/core/Typography";
import Switch from "@material-ui/core/Switch";
import Button from "@material-ui/core/Button";

import { Input } from "components/tools/Size";
import HelpIcon from "@material-ui/icons/Help";
import Tooltip from "@material-ui/core/Tooltip";

import { useStoreon } from "storeon/react";
import t from "translations";
import { useCanvasSettings  } from "utils/canvas";

const Wrap = styled.div`
  margin-top: 15px;
  width: 100%;
`;

const SwitchWrap = styled.div`
  flex-basis: 130px;
  display: flex;
  justify-content: center;
`;

const ControlsWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
`;

const DisableWrap = styled.div`
  opacity: ${props => (props.enabled ? 1 : 0.3)};
  pointer-events: ${props => (props.enabled ? "all" : "none")};
  display: flex;
  align-items: center;
  flex-basis: 206px;
  justify-content: space-between;
`;

const Description = styled.div`
  display: flex;
  align-items: center;
  svg {
    margin-left: 5px;
  }
`;

const RadiusManager = () => {
  const [enabled, setEnabled] = useState(false);
  const [radius, setRadius] = useState(2);
  const { dispatch, canvas, product } = useStoreon("canvas", "product");
  const {maxRadius, minRadius}  = useCanvasSettings();

  useEffect(() => {
    if (!canvas) {
      return;
    }
    const canvasLoadedHandler = () => {
      if (canvas.cutRadius) {
        const radius = Math.round(canvas.cutRadius / 10);
        setRadius(radius);
        setEnabled(true);
      } else {
        setEnabled(false);
      }
    };
    canvas.on("canvas:loaded", canvasLoadedHandler);
    canvas.on("cutzone:updated", canvasLoadedHandler);
    canvasLoadedHandler();
    return () => {
      canvas.off("canvas:loaded", canvasLoadedHandler);
      canvas.off("cutzone:updated", canvasLoadedHandler);
    }
  }, [canvas]);

  if (!canvas) {
    return null;
  }
  const cutZone = canvas.DPE.cutZone;
  const setCutRadius = newRadius => {
    let rad = newRadius ? parseFloat(newRadius) : parseFloat(radius);
    const [min, max] = [minRadius, maxRadius];
    if (rad < min || rad > max) {
      dispatch("notification/warning", `Radius should be ${min} - ${max} cm`);
    }
    if (rad < min) {
      rad = min;
    }
    if (rad > max) {
      rad = max;
    }
    setRadius(rad);
    cutZone.setCutRadius(rad * 10);
    cutZone.fitCutZone();
  };

  const handleSwitchChange = e => {
    setEnabled(!enabled);
    if (!enabled) {
      setCutRadius();
    } else {
      canvas.DPE.cutZone.setCutRadius(0);
    }
  };

  const handleInputChange = e => {
    setRadius(e.target.value);
  };
  const handleRadiusChange = e => {
    if (e.key === "Enter") {
      setCutRadius();
    }
  };
  const handleUpdateRadius = e => {
    setCutRadius();
  };

  return (
    <Wrap>
      <Description>
        <Typography variant="subtitle2">
          {t.radiusOption} <b>zzgl. {product?.price.radius}€</b>
        </Typography>
        <Tooltip title={t.radiusOptionDesc}>
          <HelpIcon />
        </Tooltip>
      </Description>
      <ControlsWrap>
        <SwitchWrap>
          <Switch onClick={handleSwitchChange} checked={enabled} />
        </SwitchWrap>
        <DisableWrap enabled={enabled}>
          <Input
            value={radius}
            onChange={handleInputChange}
            onKeyPress={handleRadiusChange}
          />
          <Button
            variant="contained"
            color="secondary"
            onClick={handleUpdateRadius}
          >
            Update
          </Button>
        </DisableWrap>
      </ControlsWrap>
    </Wrap>
  );
};

export default RadiusManager;
